import { ARCardFooterProps } from "./_types";
import { ARCardFooterComponent } from "./_ARBaseComponents";

const ARCardFooter = (props: ARCardFooterProps) => {
  return <ARCardFooterComponent {...props} />;
};

export default ARCardFooter;
